import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { WatchlistTitleGraphqlFragmentDoc } from '../fragments/WatchlistTitle.fragment';
export type GetTitleListV2QueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	titleListFilter?: Types.InputMaybe<Types.TitleFilter>;
	titleListSortBy?: Types.TitleListSortingV2;
	titleListType: Types.TitleListTypeV2;
	titleListAfterCursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
	watchNowFilter: Types.WatchNowOfferFilter;
	first?: Types.Scalars['Int']['input'];
	language: Types.Scalars['Language']['input'];
	sortRandomSeed?: Types.Scalars['Int']['input'];
	profile?: Types.InputMaybe<Types.PosterProfile>;
	backdropProfile?: Types.InputMaybe<Types.BackdropProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	platform?: Types.Platform;
	includeOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetTitleListV2Query = {
	__typename?: 'Query';
	titleListV2: {
		__typename?: 'TitleListConnectionV2';
		totalCount: number;
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
		edges?: Array<{
			__typename?: 'TitleListEdgeV2';
			cursor: string;
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						offers?: Array<{
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							retailPrice?: string | null;
							type: Types.OfferType;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							elementCount?: number | null;
							deeplinkRoku?: string | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
							};
						}>;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							shortDescription?: string | null;
							posterUrl?: string | null;
							isReleased: boolean;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbScore?: number | null;
								tmdbPopularity?: number | null;
							};
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
						};
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						seenState: {
							__typename?: 'ShowSeenState';
							seenEpisodeCount: number;
							releasedEpisodeCount: number;
							progress: number;
							caughtUp: boolean;
							lastSeenEpisodeNumber?: number | null;
							lastSeenSeasonNumber?: number | null;
						};
						offers?: Array<{
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							retailPrice?: string | null;
							type: Types.OfferType;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							elementCount?: number | null;
							deeplinkRoku?: string | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
							};
						}>;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							shortDescription?: string | null;
							posterUrl?: string | null;
							isReleased: boolean;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbScore?: number | null;
								tmdbPopularity?: number | null;
							};
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
						};
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  };
		}> | null;
	};
};

export const GetTitleListV2Document = gql`
	query GetTitleListV2(
		$country: Country!
		$titleListFilter: TitleFilter
		$titleListSortBy: TitleListSortingV2! = LAST_ADDED
		$titleListType: TitleListTypeV2!
		$titleListAfterCursor: String
		$watchNowFilter: WatchNowOfferFilter!
		$first: Int! = 10
		$language: Language!
		$sortRandomSeed: Int! = 0
		$profile: PosterProfile
		$backdropProfile: BackdropProfile
		$format: ImageFormat
		$platform: Platform! = WEB
		$includeOffers: Boolean = false
	) {
		titleListV2(
			after: $titleListAfterCursor
			country: $country
			filter: $titleListFilter
			sortBy: $titleListSortBy
			first: $first
			titleListType: $titleListType
			sortRandomSeed: $sortRandomSeed
		) {
			totalCount
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				...WatchlistTitleGraphql
			}
		}
	}
	${WatchlistTitleGraphqlFragmentDoc}
`;
